import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'CampAttendance';

const CampAttendanceApi: any = baseApi(endpoint);

export default CampAttendanceApi;